import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!--Eyebrow banner module hbs -->";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"banner-switch") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":10,"column":8}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div style=\"background-color: "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"background-color") : depth0), depth0))
    + "\">\r\n   \r\n  <p class=\" row eyebrow-banner_text\" style=\"background-color: "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"background-color") : depth0), depth0))
    + ";\">\r\n  "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"welcome-text") : depth0), depth0))
    + "&nbsp;<a  href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"learn-more-internal-url") : depth0), depth0))
    + "\" data-aaclickevent=\"true\"\r\n    aria-label=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"learn-more-aria-label") : depth0), depth0))
    + "\" title=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"learn-more-aria-label") : depth0), depth0))
    + "\" target=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"targetAttr") : depth0), depth0))
    + "\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"learn-more-text") : depth0), depth0))
    + "</a>\r\n</p>\r\n</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"eyebrowContent") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sales.modules/eyebrow-banner-module",
  "version": "1.0.4",
  "id": "eyebrowBannerModule",
  "containerID": "salesEyebrowBannerModule",
  "moduleName": "sales-eyebrow-banner-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "eyebrow-banner-module",
  "data": {
    "init": "EyebrowBannerModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {},
      "partials": {
        "eyebrow-banner-content": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "eyebrow-banner-content": renderTemplate
  },
  "helpers": {},
  "dependencies": {
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-param-reassign */

/**
 * EyebrowBannerModuleJs Class
 * @extends Module
 */
class EyebrowBannerModuleJs extends Module {
  /**
   * @description Creates an intance of EyebrowBannerModuleJs
   * @method constructor
   * @param {Object} options options
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @description Initiliazes the module
   * @method init
   * @returns {void}
   */
  init() {
    this.listenEyebrowEvent();
  }

  /**
  * Method to listen to the eyeBrowEvent which will pass the data to eyebrowbanner
  */
  listenEyebrowEvent = () => {
    spartaEventsUtility.sub("eyeBrowEvent", event => {
      this.renderEyebrowData(event.data);
    }, true);
  };

  /**
  * Method to generate the html snippet from the data recieved by eyeBrowEvent
  * and remove the existing message and updating it with new message in dynamic div and append it to the top of the page. 
  * * @param {*} eyebrowData - json data to compile the partial
  */
  renderEyebrowData(eyebrowData) {
    const bannerElement = document.getElementById('eyebrow-content');
    if (bannerElement && bannerElement.parentElement) {
      bannerElement.parentElement.removeChild(bannerElement);
    }
    const template = _moduleConfig.partials['eyebrow-banner-content'];
    const firstElement = document.body.firstElementChild;
    const newDiv = document.createElement('div');
    newDiv.className = " column small-8 medium-4 large-6 eyebrow-banner_container ";
    newDiv.id = "eyebrow-content";
    newDiv.innerHTML = template({
      eyebrowContent: eyebrowData
    });
    document.body.insertBefore(newDiv, firstElement);
  }
}
registerModuleClass({
  moduleClass: EyebrowBannerModuleJs,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { EyebrowBannerModuleJs as default, moduleConfig };
